import { runMigrations } from '@/store/utils/helpers'

export default async function runUserSettingsMigrations(settings: Record<string, any>) {
  const migrations = (import.meta as any).glob('../migrations/*.ts', { eager: true })
  const result = await runMigrations(settings, migrations)
  return result?.length ? Object.fromEntries(result) : null
}

export const isCredentialError = (error: any): boolean => {
  const errorType = error?.name
  return ['NotAuthorizedException', 'UserNotFoundException'].includes(errorType)
}
